import { render, staticRenderFns } from "./page-loader.vue?vue&type=template&id=5969c92a"
import script from "./page-loader.vue?vue&type=script&lang=js"
export * from "./page-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5969c92a')) {
      api.createRecord('5969c92a', component.options)
    } else {
      api.reload('5969c92a', component.options)
    }
    module.hot.accept("./page-loader.vue?vue&type=template&id=5969c92a", function () {
      api.rerender('5969c92a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/loaders/page-loader.vue"
export default component.exports